import { render, staticRenderFns } from "./footer.vue?vue&type=template&id=31a9cb2a&scoped=true"
import script from "./footer.vue?vue&type=script&lang=js"
export * from "./footer.vue?vue&type=script&lang=js"
import style0 from "./footer.vue?vue&type=style&index=0&id=31a9cb2a&prod&lang=css"
import style1 from "./footer.vue?vue&type=style&index=1&id=31a9cb2a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a9cb2a",
  null
  
)

export default component.exports